module.exports = __webpack_public_path__ + "img/TD365-white.7527f791.png";